import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { PartnersState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: PartnersState = {
    partners:[],
};


export const partners: Module<PartnersState,RootState> = {
    state,
    getters,
    actions,
    mutations
};